export const APP_STATUS = '@app_status/APP_STATUS'
